// extracted by mini-css-extract-plugin
export default {"myAccount":"style_myAccount__mliIT b-40 b-m-60 b-xl-120 t-16 t-m-60 t-l-60"};